import { sidebarNodeTypes } from '../../../config/config';
import { BaseApi } from '../../common/api/base-api.interface';
import { zOrderAPI } from '../../common/api/z-order-api';
import { GroupNodeCreateProps } from '../models/group-node-create-props';
import { getApiForNodeType } from './../../common/api/api-map';
import { createGroupNode } from './create-group-node';
import { groupObjects } from './group-objects';
import { setupGroupNode } from './setup-group-node';
import { ungroupSelection } from './ungroup-selection';

export const groupNodeAPI = (): BaseApi<GroupNodeCreateProps> => ({
  name: sidebarNodeTypes.groupNode,
  setup: setupGroupNode,
  create: createGroupNode,
  ungroup: ungroupSelection,
  group: groupObjects(sidebarNodeTypes.groupNode),
  getCursor: () => 'crosshair',
  ...getApiForNodeType(sidebarNodeTypes.groupNode),
  ...zOrderAPI,
});
